"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenHistoryList = void 0;
class TokenHistoryList extends Array {
    constructor() {
        super(...arguments);
        this.getFormattedData = () => {
            const list = new TokenHistoryList();
            if (this.length > 0) {
                this.forEach(tokenHistory => {
                    const ticket = tokenHistory.ticketEntry;
                    if (ticket.bookNumber && ticket.ticketNumber) {
                        tokenHistory.displayTicketNumber = `${ticket.gameNumber}-${ticket.bookNumber}-${ticket.ticketNumber}-${ticket.validationCode}`;
                    }
                    else if (ticket.entryCode) {
                        const pattern = '#####-#####-#####-#####-#####';
                        const entryCode = !!ticket.entryCode ? ticket.entryCode : '';
                        let i = 0;
                        tokenHistory.displayTicketNumber = pattern.replace(/#/g, () => entryCode[i++]);
                    }
                    list.push(tokenHistory);
                });
            }
            return list;
        };
    }
}
exports.TokenHistoryList = TokenHistoryList;
//# sourceMappingURL=TokenHistoryList.js.map